import { CurrencySettings } from '@ps/user-settings-models';
import { CURRENCY_CODE, Nullable } from '@ps/utils';

export const PRICING_DECIMAL_PLACES = 2;

export class LocaleToUSDConversion {
  constructor(
    private readonly _localCurrencyValue: number,
    private readonly _exchangeRateObj: Nullable<CurrencySettings>,
  ) {}

  /**
   * A USD survey has nothing to convert: legacy never fetched an exchange rate
   * for one at all, so running the CR rate over it shaved the value by the CR
   * percentage — a $1 CPI at 60% margin settled on 0.38 instead of 0.40.
   *
   * Rounded to the pricing precision the way legacy's `localToUSD` did, so the
   * figure leaving here is already the one shown and sent.
   */
  public convert(): number {
    const settings = this._exchangeRateObj;

    if (
      !settings ||
      settings.fx === CURRENCY_CODE.US ||
      !settings.rate ||
      !settings.crRate
    ) {
      return this._localCurrencyValue;
    }

    const baseAmount = this._localCurrencyValue / settings.rate;

    return Number(
      (baseAmount - baseAmount * settings.crRate).toFixed(
        PRICING_DECIMAL_PLACES,
      ),
    );
  }
}
